export default
	[
		{
			path: '',
			redirect: 'palletManagement'
		},
		// 货盘管理
		{
			path: 'palletManagement',
			name: 'palletsAndShipDates/palletManagement',
			component: () => import('@/page/palletsAndShipDates/palletManagement'),
			meta: { openKeyName: '货盘及船期', selectKeyUrl: 'palletManagement' }
		},
		// 船期管理
		{
			path: 'shipDates',
			name: 'palletsAndShipDates/shipDates',
			component: () => import('@/page/palletsAndShipDates/shipDates'),
			meta: { openKeyName: '货盘及船期', selectKeyUrl: 'shipDates' }
		},
	]



// WEBPACK FOOTER //
// ./src/router/palletsAndShipDates/index.js